// this file is generated by update_shopify_store_data.py at 2026-02-23 20:26:52.057058
var courses = [
    {
        "course_id": "E9AF198C-F317-E811-AA63-005056B178A5",
        "course_version": 7,
        "name": "Maternal Fetal Triage Index (MFTI) Education",
        "course_type": 1,
        "author_information": "The Maternal Fetal Triage Index Educational Course (MFTI) was published through the coordinated efforts of a team of dedicated AWHONN members and staff.",
        "description": "This narrated, interactive education helps sharpen nurse clinicians\u2019 clinical knowledge who work in triage or obstetric emergency department (OBED). Its core essentials focus on obstetric triage basics ensuring clinicians appropriately prioritize their initial nursing care in contribution to the prevention of maternal morbidity and mortality. Clinicians will review and analyze an algorithmic, systematic approach using the five-level acuity classification index to improve the process of triage and outcomes factoring in social determinants of health, health equity, and implicit bias.",
        "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Define triage&nbsp; </li>\r\n    <li>List the benefits of a standardized approach to obstetric triage</li>\r\n    <li>Explain the use of the Maternal Fetal Triage Index (MFTI)</li>\r\n    <li>Prioritize women using the MFTI for select obstetric triage cases&nbsp; </li>\r\n</ul>",
        "course_outline_html": "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE2F1978-C2F1-E311-941D-005056B1522B",
                "course_category_name": "AWHONN - Association of Women's Health, Obstetric, and Neonatal Nurses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0B17EB5C-EFD0-E511-AEA0-005056B11FFF",
                "course_category_name": "Patient Safety",
                "is_system_course_category": null
            },
            {
                "course_category_id": "975A148E-A6FF-E611-A64B-005056B1522B",
                "course_category_name": "Obstetric Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Allied Health Professional",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "80D46CA3-2C31-E811-A509-005056B133C3",
                "course_category_name": "AWHONN - Maternal Fetal Triage Index (MFTI)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "57A43C7A-A6FF-E611-A64B-005056B1522B",
                "course_category_name": "Emergency: General",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "The authors, reviewers, and nurse planners for this module report no conflicts of interest or relevant financial relationships.&nbsp;<br />",
            "course_level_accreditation_statement": "The Association of Women&rsquo;s Health, Obstetric and Neonatal Nurses is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Accredited status does not imply endorsement by AWHONN or the ANCC of any commercial products displayed or discussed in conjunction with an educational activity. AWHONN is approved by the California Board of Registered Nursing, provider # CEP580.&nbsp;&nbsp;",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 1.75,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];